// import React from 'react';
// import { Container, Nav, Navbar, NavDropdown } from 'react-bootstrap';
// import logoImage from './img/logoImage.jpg';

// function TopNavbar() {
//   return (
//     <div className="sticky-top">
//       <Navbar expand="lg" style={{ backgroundColor: "#00569c" }} variant="light">
//         <Container fluid>
//           <Navbar.Brand href="/" className="d-flex align-items-center">
//             <img src={logoImage} alt="Logo" className="image" />
//             <span className="brand-text">HOME</span>
//           </Navbar.Brand>

//           <Navbar.Toggle aria-controls="basic-navbar-nav" />

//           <Navbar.Collapse id="basic-navbar-nav">
//             <Nav className="me-auto">
//               <NavDropdown title="ABOUT" id="about-dropdown" menuVariant="light">
//                 <NavDropdown.Item href="international">INTERNATIONAL</NavDropdown.Item>
//                 <NavDropdown.Item href="multiple">MULTIPLE</NavDropdown.Item>
//               </NavDropdown>

//               <NavDropdown title="DISTRICTS" id="districts-dropdown" menuVariant="light">
//                 <NavDropdown.Item href="320a">320A</NavDropdown.Item>
//                 <NavDropdown.Item href="320b">320B</NavDropdown.Item>
//                 <NavDropdown.Item href="320c">320C</NavDropdown.Item>
//                 <NavDropdown.Item href="320d">320D</NavDropdown.Item>
//                 <NavDropdown.Item href="320e">320E</NavDropdown.Item>
//                 <NavDropdown.Item href="320f">320F</NavDropdown.Item>
//                 <NavDropdown.Item href="320g">320G</NavDropdown.Item>
//                 <NavDropdown.Item href="320h">320H</NavDropdown.Item>
//               </NavDropdown>

//               <Nav.Link href="contact"><strong>CONTACT</strong></Nav.Link>
//             </Nav>

//             <div className="attr-nav ms-auto mt-3 mt-lg-0">
//               <a href="upload">
//                 <button className="btn btn-warning">Upload</button>
//               </a>
//             </div>
//           </Navbar.Collapse>
//         </Container>
//       </Navbar>
//     </div>
//   );
// }

// export default TopNavbar;











import { useState, useRef, useEffect } from "react"
import { Link, NavLink, useNavigate } from "react-router-dom"
import logoImage from './img/logoImage.jpg'

const districts = ["320A", "320B", "320C", "320D", "320E", "320F", "320G", "320H"]

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false)
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [uploadHover, setUploadHover] = useState(false)
  const [activeHoverLink, setActiveHoverLink] = useState(null)
  const [hoveredDistrict, setHoveredDistrict] = useState(null)

  // Track window width for SM (640px) and MD (768px) responsiveness
  const [windowWidth, setWindowWidth] = useState(typeof window !== "undefined" ? window.innerWidth : 1024)

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth)
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  const isSm = windowWidth >= 640
  const isMd = windowWidth >= 768

  const dropdownRef = useRef(null)
  const navigate = useNavigate()

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClick(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false)
      }
    }
    document.addEventListener("mousedown", handleClick)
    return () => document.removeEventListener("mousedown", handleClick)
  }, [])

  // Inline styles object
  const styles = {
    header: {
      position: "sticky",
      top: 0,
      zIndex: 50,
      backgroundColor: "#ffffff",
      borderBottom: "1px solid #f3f4f6",
      boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)"
    },
    container: {
      maxWidth: "1280px",
      margin: "0 auto",
      paddingLeft: "1rem",
      paddingRight: "1rem"
    },
    navBar: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      height: "64px"
    },
    logoLink: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      textDecoration: "none",
      flexShrink: 0
    },
    logoImg: {
      width: "60px",
      height: "60px",
      objectFit: "fit",
      borderRadius: "4px"
    },
    brandTitle: {
      color: "#0067B1",
      fontWeight: 900,
      fontSize: "18px",
      letterSpacing: "-0.05em",
      lineHeight: "1"
    },
    brandSubtitle: {
      color: "#9ca3af",
      fontSize: "10px",
      letterSpacing: "0.1em",
      textTransform: "uppercase",
      fontWeight: 500,
      display: isSm ? "block" : "none" // Responsive equivalent to hidden sm:block
    },
    desktopNav: {
      display: isMd ? "flex" : "none", // Responsive equivalent to hidden md:flex
      alignItems: "center",
      gap: "32px"
    },
    uploadButton: {
      backgroundColor: uploadHover ? "#f0c800" : "#FFD500",
      color: "#0067B1",
      padding: "8px 20px",
      borderRadius: "6px",
      fontSize: "14px",
      fontWeight: 700,
      letterSpacing: "0.05em",
      textTransform: "uppercase",
      border: "none",
      cursor: "pointer",
      boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
      transition: "background-color 0.15s ease"
    },
    mobileToggle: {
      display: isMd ? "none" : "flex", // Responsive equivalent to md:hidden
      background: "none",
      border: "none",
      color: "#0067B1",
      padding: "6px",
      cursor: "pointer",
      alignItems: "center"
    },
    dropdownContainer: {
      position: "relative"
    },
    dropdownButton: {
      display: "flex",
      alignItems: "center",
      gap: "4px",
      fontSize: "14px",
      fontWeight: 600,
      letterSpacing: "0.1em",
      textTransform: "uppercase",
      background: "none",
      border: "none",
      cursor: "pointer",
      color: "#0067B1",
      paddingBottom: "2px",
      borderBottom: dropdownOpen ? "2px solid #FFD500" : "2px solid transparent"
    },
    dropdownMenu: {
      position: "absolute",
      top: "100%",
      left: "50%",
      transform: "translateX(-50%)",
      marginTop: "12px",
      backgroundColor: "#ffffff",
      borderRadius: "8px",
      boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
      border: "1px solid #f3f4f6",
      padding: "8px 0",
      minWidth: "160px",
      zIndex: 10
    },
    mobileMenu: {
      borderTop: "1px solid #f3f4f6",
      paddingTop: "16px",
      paddingBottom: "16px",
      display: !isMd && menuOpen ? "flex" : "none",
      flexDirection: "column",
      gap: "4px"
    }
  }

  // Dynamic style helper for NavLinks
  const getNavLinkStyle = ({ isActive }, linkName) => ({
    fontSize: "14px",
    fontWeight: 600,
    letterSpacing: "0.1em",
    textTransform: "uppercase",
    textDecoration: "none",
    color: "#0067B1",
    paddingBottom: "2px",
    borderBottom: isActive
      ? "2px solid #FFD500"
      : activeHoverLink === linkName
        ? "2px solid #004f8a"
        : "2px solid transparent",
    transition: "color 0.15s ease"
  })

  return (
    <header style={styles.header}>
      <div style={styles.container}>
        <div style={styles.navBar}>

          {/* Logo with imported image */}
          <Link to="/" style={styles.logoLink}>
            <img src={logoImage} alt="MD 320 Logo" style={styles.logoImg} />
            <div>
              <div style={styles.brandTitle}>MD 320</div>
              <div style={styles.brandSubtitle}>Lions Clubs International</div>
            </div>
          </Link>

          {/* Desktop Nav */}
          <nav style={styles.desktopNav}>
            <NavLink
              to="/"
              end
              style={(props) => getNavLinkStyle(props, "home")}
              onMouseEnter={() => setActiveHoverLink("home")}
              onMouseLeave={() => setActiveHoverLink(null)}
            >
              Home
            </NavLink>

            <NavLink
              to="/international"
              style={(props) => getNavLinkStyle(props, "international")}
              onMouseEnter={() => setActiveHoverLink("international")}
              onMouseLeave={() => setActiveHoverLink(null)}
            >
              International
            </NavLink>

            <NavLink
              to="/multiple-districts"
              style={(props) => getNavLinkStyle(props, "multiple")}
              onMouseEnter={() => setActiveHoverLink("multiple")}
              onMouseLeave={() => setActiveHoverLink(null)}
            >
              Multiple
            </NavLink>

            {/* Districts Dropdown */}
            <div style={styles.dropdownContainer} ref={dropdownRef}>
              <button
                onClick={() => setDropdownOpen((v) => !v)}
                style={styles.dropdownButton}
              >
                Districts
                <svg
                  style={{
                    width: "14px",
                    height: "14px",
                    transform: dropdownOpen ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.2s ease"
                  }}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M19 9l-7 7-7-7" />
                </svg>
              </button>

              {dropdownOpen && (
                <div style={styles.dropdownMenu}>
                  {districts.map((d) => (
                    <Link
                      key={d}
                      to={`/district/${d.toLowerCase()}`}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        padding: "8px 16px",
                        fontSize: "14px",
                        textDecoration: "none",
                        color: hoveredDistrict === d ? "#0067B1" : "#374151",
                        backgroundColor: hoveredDistrict === d ? "#f0f7ff" : "transparent",
                        fontWeight: 500,
                        transition: "all 0.15s ease"
                      }}
                      onMouseEnter={() => setHoveredDistrict(d)}
                      onMouseLeave={() => setHoveredDistrict(null)}
                      onClick={() => setDropdownOpen(false)}
                    >
                      <span
                        style={{
                          width: "6px",
                          height: "6px",
                          borderRadius: "50%",
                          backgroundColor: "#FFD500",
                          opacity: hoveredDistrict === d ? 1 : 0,
                          transition: "opacity 0.15s ease",
                          flexShrink: 0
                        }}
                      />
                      District {d}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            <NavLink
              to="/contact"
              style={(props) => getNavLinkStyle(props, "contact")}
              onMouseEnter={() => setActiveHoverLink("contact")}
              onMouseLeave={() => setActiveHoverLink(null)}
            >
              Contact
            </NavLink>
          </nav>

          {/* Upload Button + Mobile Toggle */}
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <button
              onClick={() => navigate("/upload")}
              style={styles.uploadButton}
              onMouseEnter={() => setUploadHover(true)}
              onMouseLeave={() => setUploadHover(false)}
            >
              Upload
            </button>

            <button
              style={styles.mobileToggle}
              onClick={() => setMenuOpen((v) => !v)}
              aria-label="Toggle menu"
            >
              {menuOpen ? (
                <svg style={{ width: "20px", height: "20px" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              ) : (
                <svg style={{ width: "20px", height: "20px" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              )}
            </button>
          </div>
        </div>

        {/* Mobile Menu Dropdown */}
        {menuOpen && !isMd && (
          <div style={styles.mobileMenu}>
            <NavLink to="/" end style={{ display: "block", padding: "10px 12px", fontSize: "14px", fontWeight: 600, color: "#0067B1", textDecoration: "none" }} onClick={() => setMenuOpen(false)}>Home</NavLink>
            <NavLink to="/international" style={{ display: "block", padding: "10px 12px", fontSize: "14px", fontWeight: 600, color: "#0067B1", textDecoration: "none" }} onClick={() => setMenuOpen(false)}>International</NavLink>
            <NavLink to="/multiple-districts" style={{ display: "block", padding: "10px 12px", fontSize: "14px", fontWeight: 600, color: "#0067B1", textDecoration: "none" }} onClick={() => setMenuOpen(false)}>Multiple</NavLink>

            <div style={{ padding: "4px 0" }}>
              <div style={{ padding: "10px 12px", fontSize: "14px", fontWeight: 600, color: "#0067B1" }}>Districts</div>
              <div style={{ paddingLeft: "24px", borderLeft: "2px solid #FFD500", marginLeft: "12px", display: "flex", flexDirection: "column", gap: "4px" }}>
                {districts.map((d) => (
                  <Link key={d} to={`/district/${d.toLowerCase()}`} style={{ display: "block", padding: "6px 12px", fontSize: "14px", color: "#4b5563", textDecoration: "none" }} onClick={() => setMenuOpen(false)}>
                    District {d}
                  </Link>
                ))}
              </div>
            </div>

            <NavLink to="/contact" style={{ display: "block", padding: "10px 12px", fontSize: "14px", fontWeight: 600, color: "#0067B1", textDecoration: "none" }} onClick={() => setMenuOpen(false)}>Contact</NavLink>
          </div>
        )}
      </div>
    </header>
  )
}

export function TopNavbar() {
  return (
    <div style={{
      padding: "12px",
      textAlign: "center",
      backgroundColor: "#f9fafb",
      fontSize: "14px",
      color: "#374151",
      borderBottom: "1px solid #e5e7eb"
    }}>
      TopNavbar
    </div>
  )
}